import { auth, analytics } from "src/util/firebase";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { logEvent } from "firebase/analytics";

export const Route = createFileRoute("/_auth/signout")({
  component: SignOutPage,
  staticData: {
    title: "Sign Out",
  },
  beforeLoad: async () => {
    // Track logout in Google Analytics
    logEvent(analytics, "logout");

    await auth.signOut();
    throw redirect({ to: "/signin" });
  },
});

function SignOutPage() {
  return <div> Signing out... </div>;
}
